import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { GridSortIcon } from 'app/assets/icons';
import React from 'react';
import styled from 'styled-components';

type Props = {
  e: GridHeaderCellProps; //header-cell props
  onSortClick?: React.MouseEventHandler<SVGSVGElement>; //onsortIcon click: callback for implementing dynamic sort
  sorted?: boolean; //if true show sort active icon, else in-active icon
  sortValue?: string;
};

const CustomSortableCell = ({ e, onSortClick, sorted, sortValue }: Props) => {
  const { title } = e; //title of column

  return (
    <StyledHeadCell className="k-cell-inner all-check-header">
      <span className="k-link">
        <span className="k-column-title">
          {title ?? ''}
          {sorted ? (
            <GridSortIcon
              ascendingcolor={
                sortValue?.toLowerCase() === 'asc' ? '#000000' : ''
              }
              descendingcolor={
                sortValue?.toLowerCase() === 'desc' ? '#000000' : ''
              }
              onClick={onSortClick}
              className="custom-sort-icon"
            />
          ) : (
            <GridSortIcon onClick={onSortClick} className="custom-sort-icon" />
          )}
        </span>
      </span>
    </StyledHeadCell>
  );
};

export default CustomSortableCell;
const StyledHeadCell = styled.span`
  .custom-sort-icon {
    margin: 0 0 0 8px;
    cursor: pointer;
  }
`;
